/** Minimum hours before booking start (publicData.minAdvanceHours). 0 = no restriction. */
export const parseMinAdvanceHours = publicData => {
  const raw = parseInt(publicData?.minAdvanceHours, 10);
  return Number.isFinite(raw) && raw > 0 ? raw : 0;
};

export const hoursUntilBookingStart = bookingStartDate => {
  if (!bookingStartDate || typeof bookingStartDate.getTime !== 'function') {
    return null;
  }
  return (bookingStartDate.getTime() - Date.now()) / (1000 * 60 * 60);
};

/** True when the selected start is sooner than the listing's minimum advance notice. */
export const isBookingBelowMinAdvanceHours = (minAdvanceHours, bookingStartDate) => {
  if (!minAdvanceHours || minAdvanceHours <= 0) {
    return false;
  }
  const hoursUntilStart = hoursUntilBookingStart(bookingStartDate);
  if (hoursUntilStart == null) {
    return false;
  }
  return hoursUntilStart < minAdvanceHours;
};
